import { defineStore } from 'pinia';

export const useSiteSearchBarStore = defineStore('SiteSearchBarStore', {
  state: () => ({
    siteSearchValue: '',
    searchSubmittedValue: false,
  }),
  actions: {
    setSiteSearch(value) {
      this.siteSearchValue = value;
    },
    getSiteSearch() {
      return this.siteSearchValue;
    },
    setSearchSubmitted(value) {
      this.searchSubmittedValue = value;
    },
    getSearchSubmitted() {
      return this.searchSubmittedValue;
    },
  },
});
